const COMMON_DASHBOARD_TYPES = [
    {
        name: 'Security (Legacy)',
        tagType: null,
        id: 'security',
        defaultValue: 'Security (Legacy)',
        legacy: true,
    },
    {
        name: 'CTO (Legacy)',
        tagType: null,
        id: 'cto',
        defaultValue: 'CTO (Legacy)',
        render: (featureFlags) => !featureFlags.PARTNER_FEATURES,
        legacy: true,
    },
    {
        name: 'Developer (Legacy)',
        tagType: null,
        id: 'developer',
        defaultValue: 'Developer (Legacy)',
        legacy: true,
    },
    {
        name: 'CISO (Legacy)',
        id: 'ciso',
        defaultValue: 'CISO (Legacy)',
        legacy: true,
    },
    {
        name: 'SSDLC Healthcheck',
        id: 'ssdlc_healthcheck',
        defaultValue: 'SSDLC Healthcheck',
        render: (featureFlags) => !featureFlags.PARTNER_FEATURES
    },
    {
        name: 'All Organizations',
        // name: <>All Business Units<PreviewTag tagTitle='Beta' /></>,
        id: 'all_bu_dashboard',
        defaultValue: 'All Organizations'
    },
    {
        name: 'Teams Summary',
        // name: <>Teams Summary<PreviewTag tagTitle='Beta' /></>,
        id: 'teams_summary',
        defaultValue: 'Teams Summary'
    },
    {
        name: 'Findings Flow',
        id: 'finding_flow',
        defaultValue: 'Findings Flow'
    },
    {
        name: 'Context Risk Graph',
        id: 'crg',
        defaultValue: 'Context Risk Graph',
        render: (featureFlags) => featureFlags.PM_DEMO
    }
];

export {
    COMMON_DASHBOARD_TYPES,
}